import categoryConstraints from '@/components/category-constraints/CategoryConstraints'
export default [
  {
    path: '/categoryConstraints',
    name: 'categoryConstraints',
    component: categoryConstraints,
    meta: {
      requiresAuth: true
    }
  }
]



//////////////////
// WEBPACK FOOTER
// ./src/router/categoryConstraintsRoutes
// module id = 937
// module chunks = 0